import { Avatar, Tag, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { getInitials } from "../../utils/general.util";

const status = (status) => {
  switch (status) {
    case 1:
      return {
        color: "#10b981", 
        status: "Active",
      };

    case 2:
      return {
        color: "#dc2626", 
        status: "Inactive",
      };

    default:
      return {
        color: "#64748b", 
        status: "Unknown",
      };
  }
};

const PatientListItem = ({ patient, index }) => {

    const navigate = useNavigate();
  const { Text } = Typography;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px 0px 20px 12px",
        borderTop: index === 0 ? "none" : "1px solid rgba(255,255,255,0.05)",
        cursor: "pointer",
      }}
      onClick={() => navigate(`/patient-cabinet/${patient.id}`)}
    >
      {/* Left side */}
      <div style={{ display: "flex", gap: 12 }}>
        <Avatar
          style={{
            backgroundColor: "#a855f7",
            fontWeight: 600,
          }}
        >
          {getInitials(`${patient.first_name} ${patient.last_name}`)}
        </Avatar>

        <div>
          <Text style={{ color: "#fff", fontWeight: 500 }}>
            {patient.first_name} {patient.last_name}
          </Text>
          <br />
          <Text style={{ color: "#94a3b8", fontSize: 13 }}>
            {patient.email}
          </Text>
        </div>
      </div>

         {/* Right */}
            <Tag
              style={{
                background: status(patient.status).color,
                color: "#fff",
                borderRadius: 999,
                padding: "4px 10px",
                border: "none",
                fontSize: 12,
              }}
            >
              {status(patient.status).status}
              {console.log(patient)}
            </Tag>
    </div>
  );
};

export default PatientListItem;
